module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "middle",
      "text-align": "center"
    },
    attrs: {
      "width": "5%"
    }
  }, [_c('social-icon', {
    staticClass: "channel-icon",
    attrs: {
      "type": _vm.handleChannelType(_vm.channelType)
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "project-title",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [(_vm.keyword.length > 0) ? _c('div', [_c('span', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.keyword))]), _vm._v(" "), _c('strong', [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handle))])]) : _vm._e(), _vm._v(" "), (!_vm.keyword.length) ? _c('div', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handle))])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "project-actions",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('el-button', {
    staticClass: "unlink-button",
    attrs: {
      "plain": true,
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleUnlink
    }
  }, [_vm._v("Unlink")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-596a3b9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/ChannelToCampaignLinkItem.vue
// module id = 3292
// module chunks = 3